import useDevice from "@/hooks/useDevice";
import Stack from "@mui/material/Stack";
import MobileHeader from "../MobileHeader/MobileHeader";
import SideBar from "../SideBar/SideBar";
import MainContent from "./MainContent";

type PageTemplateProps = {
  canShowHeader?: boolean;
  canShowSideBar?: boolean;
};

export default function PageTemplate({
  canShowSideBar = true,
  canShowHeader = true,
  children,
}: React.PropsWithChildren<PageTemplateProps>) {
  const { isDesktop } = useDevice();

  return (
    <Stack direction="row" sx={{ height: "100dvh", overflow: "hidden" }}>
      {isDesktop && canShowSideBar && <SideBar />}

      <Stack direction="column" sx={{ minHeight: 0, width: "100%" }}>
        {!isDesktop && canShowHeader && <MobileHeader />}

        <MainContent>{children}</MainContent>
      </Stack>
    </Stack>
  );
}
